module.exports = __webpack_public_path__ + "45517b6ae37274e988ac3005c09e4ac3.pdf";